import React from 'react';
import { Link } from 'react-router-dom';
import { reviews } from '../../data/reviews';
import { getProduct } from '../../utils/products';
import { Stars } from '../shop/Stars';
export function ReviewsSection() {
  return <section className="border-t border-line" data-id="element-84" data-mp="1b1kapp6zch9q">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-85" data-mp="1ayg28fmhezd9">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-86" data-mp="163is15dgujys">
          <h2 className="text-3xl font-semibold tracking-display text-ink sm:text-4xl" data-id="element-87" data-mp="23oetmho5f8l3">4,8 uit 3.100+ reviews</h2>
          <Stars rating={4.8} size="md" data-id="element-88" data-mp="1yqwhkieu4d8v" />
        </div>
        <ul className="mt-10 grid gap-10 md:grid-cols-3 md:gap-12" data-id="element-89" data-mp="1tr0dkj650ltb">
          {reviews.map(r => {
          const p = getProduct(r.product);
          return <li key={r.name} className="flex flex-col" data-id="element-90" data-mp="1oua0m4pmq6c4">
                <p className="text-lg leading-relaxed text-ink" data-id="element-91" data-mp="id6enezgbv0t">“{r.text}”</p>
                <div className="mt-auto flex items-center justify-between pt-6 text-sm" data-id="element-92" data-mp="dcim2ovkr64h">
                  <span className="font-medium" data-id="element-93" data-mp="17qjtwt287c2z">{r.name}</span>
                  {p && <Link to={`/product/${p.slug}`} className="text-muted underline underline-offset-4 hover:text-ink" data-id="element-94" data-mp="1cp3eap168ft8">
                      {p.name}
                    </Link>}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}